import Decision from "../Components/Decision";
import Footer from "../Components/Footer";
import Header from "../NewEvent/Header";
import CreateForm from "./CreateForm";
import EventList from "./EventList";
import withAuth from "../auth/withAuth";

const EventHome = () => {

    return (
      
      <div>
        <Header/>
        {/* <CreateForm /> */}
        <EventList />
        <Decision/>
        <Footer />
      </div>
    );
  }

  export default withAuth(EventHome);